import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { Observable } from 'rxjs';
import { take, tap } from 'rxjs/operators';

import { downloadCsvData } from '@libs/src/utilities/csv.utilities';
import {
  DownloadCsvTemplateType,
  templates,
} from '@main-client/src/app/download-csv-template/download-csv-template.helper';

@Component({
  selector: 'app-download-csv-template',
  templateUrl: './download-csv-template.component.html',
})
export class DownloadCsvTemplateComponent {
  @Input() text: string;
  @Input() type: DownloadCsvTemplateType;
  @Input() data: string[][];
  @Input() dataStream: Observable<string[][]>;
  @Input() color: ThemePalette;
  @Input() title: string;
  @Input() isButton: boolean;
  @Input() disabled: boolean;
  @Input() styleClass: string;
  @Output() clicked = new EventEmitter();

  downloadTemplate() {
    if (this.disabled) {
      return;
    }
    this.clicked.emit();
    if (this.data && this.title) {
      return downloadCsvData(this.data, this.title);
    }
    if (this.dataStream) {
      return this.dataStream
        .pipe(
          take(1),
          tap((data: string[][]) => downloadCsvData(data, this.title)),
        )
        .subscribe();
    }
    if (this.type) {
      const csvTemplate = (templates as any)[this.type];
      if (!csvTemplate) {
        return;
      }
      return downloadCsvData(csvTemplate.data, csvTemplate.title);
    }
  }
}
